<template>
  <drag-modal
    :visible="visible"
    :loading="loading"
    :title="title"
    width="90%"
    @cancel="() => (visible = false)"
  >
    <div class="details" style="width: 99%; height: 88vh; z-index: 1;">
      <div class="details_left">
        <div class="detail_real_time"><span>实时模拟</span></div>
        <a-row class="detail_main_r1">
            <a-col :span="14">
                <div class="detail_data1">
                <ul style="float:right">
                    <li class="detail_data1_li">
                    <div>{{ data.Record.RecordDate }}</div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>重量</div>
                        <div>{{ parseFloat(data.Record.RealtimeWeight).toFixed(2) }}吨</div>
                    </div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>速度</div>
                        <div>{{ parseFloat(data.Record.RealtimeSpeed).toFixed(2) }}米/秒</div>
                    </div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>高度</div>
                        <div>{{ parseFloat(data.Record.RealtimeHeight).toFixed(2) }}米</div>
                    </div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>当前楼层</div>
                        <div>{{ data.Record.RealtimeFloor }}楼</div>
                    </div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>运载人数</div>
                        <div>{{ data.Record.RealtimePeople }}人</div>
                    </div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>实时风速</div>
                        <div>
                        {{ parseFloat(data.Record.RealtimeWindSpeed).toFixed(2) }}米/秒
                        </div>
                    </div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>实时风级</div>
                        <div>
                        {{ data.Record.RealtimeWindLevel }}级
                        </div>
                    </div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>X倾角</div>
                        <div>{{ parseFloat(data.Record.RealtimeDipX).toFixed(2) }}度</div>
                    </div>
                    </li>
                    <li class="detail_data1_li">
                    <div>
                        <div>Y倾角</div>
                        <div>{{ parseFloat(data.Record.RealtimeDipY).toFixed(2) }}度</div>
                    </div>
                    </li>
                </ul>
                </div>
            </a-col>
          <a-col :span="7">
            <div class="elevator">
              <img src="@/assets/image/elevator/elevator-body.png" alt="" class="elevatorBody">
              <img src="@/assets/image/elevator/elevator-box.png" alt="" class="elevatorBox" :style="{
                  bottom: data.Record.RealtimeHeight/2+'vh'
              }">
            </div>
          </a-col>
          <a-col :span="3">
            <div style="height: 20vh; width: 20vh; text-align: center;">
              <img
                v-if="data.Status == 2"
                src="../../assets/image/status/online.png"
                alt="正常工作中"
              />
              <img
                v-else-if="data.Status == 3"
                src="../../assets/image/status/warry.png"
                alt="设备异常"
              />
              <img
                v-else
                src="../../assets/image/status/offline.png"
                alt="设备离线"
              />
              <p v-if="data.Status == 2">正常工作中</p>
              <p v-else-if="data.Status == 3">设备异常</p>
              <p v-else>设备离线</p>
            </div>
          </a-col>

        </a-row>
      </div>
      <div style="margin-top: 20px;float: left;">
        <div class="details_left1" style="float: left;">
          <div class="details_left1_datas_box">
            <div class="details_left1_datas"><span>近期数据跟踪</span></div>
            <!-- <div class="tajilishi">塔机历史</div> -->
          </div>
          <div
            style="margin:0 auto;width:auto; height: 28.2vh;display: -ms-flexbox;display: -webkit-box;display: flex;-ms-flex-pack: justify;-webkit-box-pack: justify;justify-content: space-between;"
          >
          
          <dv-scroll-board
            :config="realtimeWorkConfig"
            ref="realtimeWorkBox"
            style="height:3.4rem"
          />
          </div>
        </div>
        <div class="details_left2" style="float: left;">
          <div class="details_left2_tasi detail_real_time">
            <span>司机状态</span>
          </div>
          <div class="details_left2_div1">
            <img
              src="data:image/png;base64,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"
              alt=""
            />
          </div>
          <div class="detail_left2_tit">
            <div v-if="data.OperaterName" class="detail_left2_name">
              <span>姓名：</span> <span>{{ data.OperaterName }}</span>
            </div>
            <div v-if="!data.OperaterName" class="detail_left2_mount_guard">
              <span>未获取到司机信息</span>
            </div>
          </div>
        </div>
      </div>
      <div class="details_right">
        <div class="details_right1">
          <div style="width: 96%; height: 28vh; margin-left: 2%;">
            未配置吊钩可视化设备
          </div>
        </div>
        <div class="details_right2">
          <div class="details_right2_fenxi">
            <p class="details_right2_fenxi_p1">
              故障分析：<span>[{{ alarmStatus }}]</span>
            </p>
            <p>
              <span>分析时间：</span> <span>{{ data.Record.RecordDate }}</span>
            </p>
          </div>
        </div>
        <div class="details_right3">
          <div class="d-flex pt-2 pl-2">
            <span style="color:#5cd9e8">
              <icon name="chart-line"></icon>
            </span>
            <div class="d-flex">
              <span class="fs-xl text mx-2">近期工作循环</span>
            </div>
          </div>
          <dv-scroll-board
            :config="cycleWorkConfig"
            ref="cycleWorkBox"
            style="height:4.0rem"
          />
        </div>
      </div>
    </div>
  </drag-modal>
</template>
<script>
import DragModal from "@/components/DragModal";
import moment from "moment";

const cycleTemplat = {
  header: ["开始时间", "结束时间", "吊重","人数"],
  data: [],
  rowNum: 6, //表格行数
  headerHeight: 35,
  headerBGC: "#0f1325", //表头
  oddRowBGC: "#0f1325", //奇数行
  evenRowBGC: "#171c33", //偶数行
  index: false,
  columnWidth: [140, 140],
  align: ["center"],
  hoverPause: true
};
const realtimeWorkTemplat={
    header: ["记录时间", "重量", "高度","速度","楼层","人数","风速","风级","倾角X","倾角Y","方向"],
  data: [],
  rowNum: 6, //表格行数
  headerHeight: 25,
  headerBGC: "#0f1325", //表头
  oddRowBGC: "#0f1325", //奇数行
  evenRowBGC: "#171c33", //偶数行
  index: false,
  columnWidth: [150,95,95,95,95,95,95,95,95,95,95,95],
  align: ["center"],
  hoverPause: true
}
export default {
  data() {
    return {
      loading: true,
      visible: false,
      title: "",
      videoUrl: "",
      options: {
        width: "100%",
        autoplay: true,
        isLive: true, //切换为直播流的时候必填
        useFlashPrism: false, //指定为flash
        disableSeek: true, //禁用进度条的Seek，默认值为false
      },
      connection: null,
      queryParam: {},
      alarmCount: 0,
      alarmStatus: "正常",
      data: {
        Config: {},
        Record: {}
      },
      cycleWorkConfig: cycleTemplat,
      realtimeWorkConfig:realtimeWorkTemplat
    };
  },
  components: {
    DragModal,
  },
  created: function() {
    this.loading = false;
    this.connection = this.$op.getConnect(this);
    if (this.connection) this.setconnection();
  },
  methods: {
    moment,
    openForm(device) {
      this.data = device;
      this.title = device.Name + "(" + device.Code + ")";
      this.queryParam = { ProId: device.ProId, DeviceId: device.Id };
      this.loading = false;
      this.visible = true;
      this.loadcyclerecord();
      this.loadrealtimerecord();
      this.getconnection();
      this.cancelLoading();
    },
    
    loadcyclerecord() {
      this.loading = true;
      this.$http
        .post("/DeviceManage/DeviceElevatorRecordCycle/GetLastDataList", {
          Search: {
            id: this.data.Id
          },
          PageRows: 7,
          SortField: "WorkStartDate",
          SortType: "desc"
        })
        .then(resJson => {
          this.loading = false;
          let cycleWorkData = cycleTemplat;

          if (resJson.Data && resJson.Data.length > 0) {
            for (let index = 0; index < resJson.Data.length; index++) {
              const element = resJson.Data[index];
              cycleWorkData.data.push([
                moment(element.WorkStartDate).format("yyyy-MM-DD HH:mm"),
                moment(element.WorkEndDate).format("yyyy-MM-DD HH:mm"),
                element.MaxWeight,
                element.MaxPeople
              ]);
            }
            this.cycleWorkConfig = cycleWorkData;
            this.$refs["cycleWorkBox"].updateRows(cycleWorkData.data);
          }
        });
    },
    loadrealtimerecord() {
      this.loading = true;
      this.$http
        .post("/DeviceManage/DeviceElevatorRecord/GetLastDataList", {
          Search: {
            id: this.data.Id
          },
          PageRows: 7,
          SortField: "RecordDate",
          SortType: "desc"
        })
        .then(resJson => {
          this.loading = false;
          let realtimeWorkData = realtimeWorkTemplat;

          if (resJson.Data && resJson.Data.length > 0) {
            for (let index = 0; index < resJson.Data.length; index++) {
              const element = resJson.Data[index];
              var workDirection = '未运行'
              if(element.WorkingType == 1)
              workDirection = "<span  class='colorGrass'>↑</span>"
              else if(element.WorkingType == 2)
              workDirection = "<span  class='colorRed'>↓</span>"
              realtimeWorkData.data.push([
                moment(element.RecordDate).format("yyyy-MM-DD HH:mm"),
                element.RealtimeWeight,
                element.RealtimeHeight,
                element.RealtimeSpeed,
                element.RealtimeFloor,
                element.RealtimePeople,
                element.RealtimeWindSpeed,
                element.RealtimeWindLevel,
                element.RealtimeDipX,
                element.RealtimeDipY,
                workDirection
              ]);
            }
            this.realtimeWorkConfig = realtimeWorkData;
            this.$refs["realtimeWorkBox"].updateRows(realtimeWorkData.data);
          }
        });
    },
    loadlastrecord() {
      this.$http
        .post("/DeviceManage/DeviceElevator/GetLastRecord", { id: this.data.Id })
        .then(x => {
          this.loading = false;
          this.data.Record = x;
        });
    },
    cancelLoading() {
      setTimeout(() => {
        this.getconnection();
        if (!this.connection || typeof this.connection == "undefined") {
            this.loadlastrecord();
            this.loadrealtimerecord();
          this.loadcyclerecord();
        } else {
          this.setconnection();
        }
      }, 60 * 1000);
    },
    getconnection() {
      if (!this.connection) this.connection = this.$op.getConnect(this);
    },
    setconnection() {
      this.connection.on("elevatorrealtime", x => {
        console.log(x)
      });
      this.connection.on("elevatorcycle", x => {
        this.cycleWorkConfig.data.push([
          moment(x.data.workStartDate).format("yyyy-MM-DD HH:mm"),
          moment(x.data.workEndDate).format("yyyy-MM-DD HH:mm"),
          x.data.workWeight
        ]);
        this.$refs["cycleWorkBox"].updateRows(this.cycleWorkConfig.data, 1);
      });
    }
  }
};
</script>
<style lang="scss">
.details {
  .detail_real_time {
    position: relative;
    margin: 10px;
  }
  .details_left {
    width: 75%;
    height: 48vh;
    border: 1px solid #85a2e2;
    margin-left: 1%;
    float: left;
    .detail_real_time {
      position: relative;
      margin: 10px;
    }
    .elevator{        
    height: 40vh;
    width: 42%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    .elevatorBody{
        height: 100%;
    }
    .elevatorBox{
    height: 9vh;
    position: absolute;
    bottom: 5vh;
    left: 51.8%;
    transition: all 2s;
    }
    }
    div > .detail_data1 > ul .detail_data1_li {
      float: left;
    width: 20%;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    -ms-flex-pack: center;
    -webkit-box-pack: center;
    justify-content: center;
    height: 9vh;
    background: #27c656;
    border-radius: 10px;
    text-align: center;
    line-height: 3.5vh;
    font-weight: 700;
    color: #000;
    margin-left: 4%;
    margin: 10px;
    }
  }
  .details_left1 {
    width: 83.7%;
    height: 34vh;
    border: 1px solid #85a2e2;
    margin-left: 1.3%;
    margin-right: 0.1%;
    .details_left1_datas_box {
      margin: 0 auto;
      width: 90%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-pack: justify;
      justify-content: space-between;
      .details_left1_datas {
        position: relative;
        width: 90%;
        height: 30px;
        margin: 0 auto;
        background: #3156b7;
        line-height: 30px;
        margin-top: 20px;
        padding-left: 10px;
      }
      .tajilishi {
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        padding: 0 10px;
        background: #0056a9;
        cursor: pointer;
      }
    }
  }
  .details_left2 {
    width: 14.9%;
    height: 34vh;
    border: 1px solid #85a2e2;
    .details_left2_div1 {
      position: relative;
    }
    .details_left2_div1 > img {
      position: absolute;
      height: 140px;
      width: 110px;
      left: 28%;
      top: 10px;
      font-size: 12px;
    }
    .detail_left2_tit {
      position: relative;
      top: 170px;
      line-height: 28px;
      left: 22px;
      font-size: 12px;
    }
  }
  .details_right {
    position: absolute;
    width: 23%;
    right: 10px;

    .details_right1 {
      height: 35vh;
      border: 1px solid #85a2e2;
    }
    .details_right2 {
      height: 10vh;
      border: 1px solid #85a2e2;
      margin-top: 10px;
      .details_right2_fenxi {
        width: 100%;
        line-height: 30px;
        margin-top: 10px;
        margin-left: 4%;
        font-size: 12px;
      }
    }
    .details_right3 {
      position: relative;
      height: 36.7vh;
      border: 1px solid #85a2e2;
      margin-top: 10px;
    }
  }
}
</style>
